import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import { environment } from '../../../../environments/environment';

import {
  AdvisorUsageBreakdownModel,
  StructureAdvisorWalletModel,
  TokenTransferRequest,
  TokenTransferResultModel,
} from '../../model';

/**
 * FIN-7296: AI credit transfers inside the company structure. The backend verifies on every call that the
 * caller is a company admin and that the advisor belongs to the caller's own company or a company below it.
 */
@Injectable({ providedIn: 'root' })
export class AiTokenTransferService {
  private readonly base: string = `${environment.apiEndpoint}/ai/tokens/transfers`;

  constructor(private http: HttpClient) {}

  /** The advisor's wallet plus the last transfer they received. */
  public getAdvisorWallet(advisorId: string): Observable<StructureAdvisorWalletModel> {
    return this.http.get<StructureAdvisorWalletModel>(`${this.base}/advisors/${advisorId}/wallet`);
  }

  /** Moves credits from the logged-in admin's wallet to the advisor's wallet. */
  public transfer(request: TokenTransferRequest): Observable<TokenTransferResultModel> {
    return this.http.post<TokenTransferResultModel>(this.base, request);
  }

  /** Tokens the advisor spent per feature over the last `months` calendar months (current month included). */
  public getAdvisorUsage(advisorId: string, months: number): Observable<AdvisorUsageBreakdownModel> {
    const params = new HttpParams().set('months', months);

    return this.http.get<AdvisorUsageBreakdownModel>(`${this.base}/advisors/${advisorId}/usage`, { params });
  }
}
